import { useState } from "react";
import useDebounce from "react-use/lib/useDebounce";

export const useDebouncedValue = <T>(
  initialState: T,
  delay: number
): [T, T, (value: T) => void] => {
  const [value, setValue] = useState(initialState);
  const [debounced, setDebounced] = useState(initialState);

  useDebounce(() => setDebounced(value), delay, [value]);

  return [value, debounced, setValue];
};
